<template>
  <section v-if="animalIds.length" class="mb-16 md:col-span-full md:row-end-3 md:row-start-2">
    <div v-if="showTitle || showDescription || url" class="grid grid-cols-12 mb-6">
      <div v-if="showTitle || url" class="col-span-full justify-between md:flex">
        <h2 v-if="showTitle" class="col-span-full mb-2 text-xl font-bold leading-none uppercase sm:text-2xl md:col-span-7 md:mb-0 lg:text-3xl">
          {{ title || t_('title') }}
        </h2>
        <AtomButton v-if="url" :url="url" button-type="primary" class="md:ml-auto">
          {{ urlLabel || t_('url-label') }}
          <AtomIconArrowRight class="ml-3 w-4" />
        </AtomButton>
      </div>
      <div v-if="showDescription" class="prose prose--app col-span-full mt-3 max-w-none md:col-span-7" v-html="t_('description')" />
    </div>
    <MoleculeCarousel v-if="animalIds.length" :slides="animalIds" background="bg-app-green-200" type="slider">
      <template #slide="{ slide }">
        <OrganismLoaderFromAnimalId v-slot="{ animal }" :animal-id="slide">
          <MoleculeCarouselSlideAnimal :slide="animal" :translation-group="animal.animalType" />
        </OrganismLoaderFromAnimalId>
        <span style="display: none"><!-- THIS SPAN FIXES A TIMING ISSUE WHEN GLIDEJS CLONES THE SLIDE --></span>
      </template>
    </MoleculeCarousel>
  </section>
</template>

<script setup lang="ts">
import { setupTranslationPrefixer } from '~/composables/util'

interface Props {
  animalIds?: string[]
  description?: string
  showDescription?: boolean
  showTitle?: boolean
  title?: string
  translationGroup?: string
  url?: string
  urlLabel?: string
}

const props = withDefaults(defineProps<Props>(), {
  animalIds: () => [],
  description: undefined,
  showDescription: true,
  showTitle: true,
  title: undefined,
  translationGroup: 'default',
  url: undefined,
  urlLabel: undefined,
})

const { t_ } = setupTranslationPrefixer('HighlightedAnimals', props.translationGroup)
</script>
